import React from 'react';
import { useTranslation } from '../../i18n';

const GamePausedOverlay: React.FC = () => {
  const { t } = useTranslation();

  return (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(15, 23, 42, 0.72)',
      backdropFilter: 'blur(4px)',
      pointerEvents: 'none',
    }}
    aria-live="polite"
    aria-label={t('gameplay.paused.ariaLabel')}
  >
    <div
      style={{
        padding: '1.25rem 2rem',
        borderRadius: '12px',
        background: 'rgba(15, 23, 42, 0.95)',
        border: '1px solid rgba(var(--color-primary-rgb), 0.45)',
        boxShadow: '0 0 24px rgba(var(--color-primary-rgb), 0.25)',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>⏸️</div>
      <div style={{ color: '#F8FAFC', fontSize: '1.25rem', fontWeight: 700 }}>{t('gameplay.paused.title')}</div>
      <div style={{ color: 'rgba(248, 250, 252, 0.7)', fontSize: '0.9rem', marginTop: '0.35rem' }}>
        {t('gameplay.paused.subtitle')}
      </div>
    </div>
  </div>
  );
};

export default GamePausedOverlay;
